import React, { useState, useEffect } from 'react';
import { Button, Nav, NavItem, NavLink } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';

//Components
import MainCard from '../../../../../components/MainCard';
import Identificacao from './Identificacao';
import Questoes from './Questoes';


//Api
import formulario_api from '../../../../../api/formulario_api';

//Context
import { useAuth } from '../../../../../context/auth';

//Helpers
import { showMessage } from '../../../../../helpers/message';
import { getSessionCookie } from '../../../../../helpers/cookies';

function initialStateFormulario(secretaria_Id) {
    return {
        identificacao: "",
        status: "Ativo",
        finalidade: "Fiscalização",
        secretaria_Id: secretaria_Id
    }
}

export default function FormularioStepper({ id, btnVoltar, editavel }) {
    //Dados de autenticação
    const session = getSessionCookie();
    
    //Estado de controle dos dados do formulario
    const [formulario, setFormulario] = useState(initialStateFormulario(session.secretaria_Id));

    //Estado de controle do passo ativo
    const [activeStep, setActiveStep] = useState(1);

    const { setLoading } = useAuth();

    const loadFormulario = (id = null) => {
        if (id != null || formulario?.id) {
            setLoading(true);
            formulario_api.getItem(id ?? formulario?.id)
                .then(response => {

                    response.data?.formularioQuestos?.map(value => {
                        value.obrigatorio = value.obrigatorio ? "true" : "false";
                        value.possuiDependencia = value.possuiDependencia ? "true" : "false";
                        value.deletado = value.deletado ? "true" : "false";
                        value.sequencia = value.sequencia.toString();
                        return value;
                    });
                    setFormulario(response.data);
                })
                .catch(err =>  showMessage("Erro", err.message, "error", null))
                .finally(f => setLoading(false));
        }
    }

    useEffect(() => {
        loadFormulario(id);
    }, []);
    //Função que retorna o valor do passo ativo
    const getContent = () => {
        switch (activeStep) {
            case 1:
                return <Identificacao
                    formulario={formulario}
                    setFormulario={setFormulario}
                    loadFormulario={loadFormulario}
                    editavel={editavel}
                />
            case 2:
                return <Questoes
                    formulario={formulario}
                    loadFormulario={loadFormulario}
                    editavel={editavel}
                />
        }
    }

    return (
        <>
            <Button onClick={btnVoltar} className='px-4'><FontAwesomeIcon icon={faAngleLeft} className='me-2' /> Voltar</Button>
            <MainCard>
                <h4>Formulário</h4>
                <Nav tabs>
                    <NavItem className='ms-2'>
                        <NavLink
                            role='button'
                            style={{ backgroundColor: activeStep == 1 ? "#fff" : "#ccc" }}
                            className={`${activeStep == 1 ? "active fw-bold text-success" : "text-secondary "}`}
                            onClick={() => { setActiveStep(1); }}
                        >
                            Formulário
                        </NavLink>
                    </NavItem>
                    <NavItem className='ms-2'>
                        <NavLink
                            role='button'
                            style={{ backgroundColor: activeStep == 2 ? "#fff" : "#ccc" }}
                            className={`${activeStep == 2 ? "active fw-bold text-success" : "text-secondary "}`}
                            onClick={() => {
                                if (!formulario.id) {
                                    showMessage("Aviso", "Salve o formulario para poder preencher as questões", "info", null);
                                    return;
                                }

                                setActiveStep(2);
                            }}
                        >
                            Questões
                        </NavLink>
                    </NavItem>
                </Nav>
                <div className="mt-4">
                    {getContent()}
                </div>
            </MainCard>
        </>
    )
}